import { getProvider } from '../../api/platform';
export var canShowOfferwallBanner = function (offerwall) {
    var provider = getProvider();
    switch (offerwall) {
        case 'bonus-missions':
            return provider === 'google' || provider === 'ios';
        case 'playtime':
            return provider === 'google';
        default:
            return false;
    }
};
